<template>
  <div class="collection__grid product-grid container">
    <template
      v-for="(product, index) in currentPageProducts"
      :key="`template-${product.handle}`"
    >
      <transition-group name="product-grid">
        <ProductItem
          :key="product.handle"
          :product="product"
          :index="index"
          :collection-template="true"
        />
      </transition-group>

      <HighlightedProducts
        v-if="index === 3"
        :index="index"
      />
    </template>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useCollectionStore } from '../pinia/CollectionStore'

import ProductItem from '../components/product-item'
import HighlightedProducts from './collection-highlilghted-products'

export default {
  components: {
    ProductItem,
    HighlightedProducts
  },
  computed: {
    ...mapState (useCollectionStore, [
      'currentPageProducts',
    ]),
  }
}
</script>
